import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Content = styled.div`
    height: max-content;
    
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%;
    }
`;

export const Category = styled.div`
    background-color: ${COLORS.BgSubstrate};
    border-radius: ${BorderRadius.OuterBlockRadius};
    border-color: transparent;
    padding: 24px;
    width: 480px;
    cursor: pointer;
    
    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 340px;
    }
    
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%;
    }
`;

export const Title = styled.p`
    ${FONTS.H5};
    margin-bottom: 4px;
    width: 100%;
    word-break: break-word;
`;

export const SubTitle = styled.p`
    ${FONTS.XS};
    word-break: break-word;
`;
